export default __webpack_public_path__ + "static/media/EsilioPic7.dba88714.png";